import { render, staticRenderFns } from "./IfaceSelector.vue?vue&type=template&id=ffdba80c&scoped=true&"
import script from "./IfaceSelector.vue?vue&type=script&lang=js&"
export * from "./IfaceSelector.vue?vue&type=script&lang=js&"
import style0 from "./IfaceSelector.vue?vue&type=style&index=0&id=ffdba80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdba80c",
  null
  
)

export default component.exports